import React from 'react';
import { TileIds } from '../../../util/tileEnums';

const copayCoinsuranceModalDetailsDescriptions = [
  {
    id: TileIds.COPAY_COINSURANCE_MODAL_IN_NETWORK,
    description: 'In-network',
    subtext: (
      <span>
        <b>Savings tip:</b> It's cheaper to visit in-network clinics.
      </span>
    ),
    icon: '/images/insurance/in_network_tip.svg',
    isInNetwork: true,
  },
  {
    id: TileIds.COPAY_COINSURANCE_MODAL_OUT_OF_NETWORK,
    description: 'Out-of-network',

    subtext: <span>You pay more out-of-network. Some services may not be covered.</span>,
    icon: '/images/insurance/out_network_tip.svg',
    isInNetwork: false,
  },
];
export { copayCoinsuranceModalDetailsDescriptions };
